// extracted by mini-css-extract-plugin
module.exports = {"panel":"PanelBase_panel__2Qicu","container":"PanelBase_container__2K4GF","overlay":"PanelBase_overlay__LJGki"};